import { ApiEntity, RELATION_HAS_PART } from '@backstage/catalog-model';
import { EntityRelatedEntitiesGridItem } from './EntityRelatedEntitiesGridItem';
import { EntityTable } from '@backstage/plugin-catalog-react';
import { ApiTypeTitle } from '@backstage/plugin-api-docs';
import { EntityGridItemProps } from './EntityGridItemProps';

export const HasApisGridItem = (props: EntityGridItemProps) => {
  return (
    <EntityRelatedEntitiesGridItem
      {...props}
      relationFilter={{
        type: RELATION_HAS_PART,
        kind: 'API',
      }}
      title={props.title ?? 'Has APIs'}
      orderedBy={['spec.type', 'metadata.name']}
      columns={[
        EntityTable.columns.createEntityRefColumn({ defaultKind: 'API' }),
        EntityTable.columns.createOwnerColumn(),
        {
          title: 'Type',
          field: 'spec.type',
          render: entity => <ApiTypeTitle apiEntity={entity as ApiEntity} />,
        },
        EntityTable.columns.createSpecLifecycleColumn(),
      ]}
      lgColumns={[
        EntityTable.columns.createEntityRefColumn({ defaultKind: 'API' }),
        EntityTable.columns.createOwnerColumn(),
        {
          title: 'Type',
          field: 'spec.type',
          render: entity => <ApiTypeTitle apiEntity={entity as ApiEntity} />,
        },
        EntityTable.columns.createSpecLifecycleColumn(),
        EntityTable.columns.createMetadataDescriptionColumn(),
      ]}
    />
  );
};
